// 模板配置状态管理
export default {
  namespaced: true,
  
  state: {
    config: {
      name: '默认发货单[新版]',
      paperSize: 'A4',
      width: 210,
      height: 297,
      marginTop: 10,
      marginLeft: 10,
      orientation: 'portrait',
      outputDirection: 'portrait',
      printStyle: 'default',
      printColumns: 'single',
      showBorder: 'yes',
      printByWeight: 'none',
      printByCategory: 'off',
      autoFillRows: '',
      rowsPerPage: 0,
      showConsigneeSignature: false,
      showPagination: false,
      showProductHeader: true,
      showMainHeader: true,
      showMainFooter: false
    },
    zoomLevel: 100,
    activeTab: 'basic'
  },
  
  mutations: {
    SET_CONFIG(state, { key, value }) {
      state.config[key] = value
    },
    
    SET_ZOOM_LEVEL(state, level) {
      state.zoomLevel = level
    },
    
    SET_ACTIVE_TAB(state, tab) {
      state.activeTab = tab
    },
    
    RESET_CONFIG(state) {
      // 重置为默认配置
      Object.assign(state.config, {
        name: '默认发货单[新版]',
        paperSize: 'A4',
        width: 210,
        height: 297,
        marginTop: 10,
        marginLeft: 10,
        orientation: 'portrait',
        outputDirection: 'portrait',
        printStyle: 'default',
        printColumns: 'single',
        showBorder: 'yes',
        printByWeight: 'none',
        printByCategory: 'off',
        autoFillRows: '',
        rowsPerPage: 0,
        showConsigneeSignature: false,
        showPagination: false,
        showProductHeader: true,
        showMainHeader: true,
        showMainFooter: false
      })
    }
  },
  
  actions: {
    updateConfig({ commit }, payload) {
      commit('SET_CONFIG', payload)
    },
    
    setZoomLevel({ commit }, level) {
      commit('SET_ZOOM_LEVEL', level)
    },
    
    setActiveTab({ commit }, tab) {
      commit('SET_ACTIVE_TAB', tab)
    },
    
    resetTemplate({ commit }) {
      commit('RESET_CONFIG')
    }
  },
  
  getters: {
    printAreaStyle: (state) => {
      const isLandscape = state.config.orientation === 'landscape'
      return {
        width: isLandscape ? `${state.config.height}mm` : `${state.config.width}mm`,
        height: isLandscape ? `${state.config.width}mm` : `${state.config.height}mm`,
        marginTop: `${state.config.marginTop}mm`,
        marginLeft: `${state.config.marginLeft}mm`
      }
    }
  }
}
